/**
 * UN8 matching configuration — faith bands, ancestry mode, membership scope.
 */

export interface FaithBand {
  /** Inclusive lower bound of the 10–100 faith scale. */
  min: number;
  code: string;
  label: string;
}

export const FAITH_BANDS: FaithBand[] = [
  { min: 90, code: "all_word", label: "All the Word of G-d" },
  { min: 70, code: "deep", label: "Deep" },
  { min: 50, code: "semi_deep", label: "Semi-deep" },
  { min: 30, code: "practising", label: "Practising" },
  { min: 10, code: "seeking", label: "Seeking" },
];

export function faithBand(percent: number | null): FaithBand | null {
  if (percent == null) return null;
  return FAITH_BANDS.find((b) => percent >= b.min) ?? null;
}

/**
 * `"preference"` — ancestry contributes 10 % of the affinity score.
 * `"gate"`       — a member outside the accepted list is never shown at all.
 */
export const ANCESTRY_MODE: "preference" | "gate" = "preference";

/** Christians only — positive membership wording in all user-facing copy. */
export const FAITH_SCOPE: "christian" = "christian";
